import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isPicture, isVideo } from '../../../utils/helpers';
import GlobalPreloader from '../../../components/Preloader/GlobalPreloader';
import PracticeDetailCaseAside from './PracticeDetailCaseAside';
import formatDate from '../../../utils/formatDate';
import paths from '../../../paths';
import AttachedContent from '../../../components/AttachedContent/AttachedContent';
import Preloader from '../../../components/Preloader/Preloader';

export default class PracticeDetailCase extends Component {
  static propTypes = {
    practice: PropTypes.shape({
      alias: PropTypes.string.isRequired,
      comments: PropTypes.array.isRequired,
      contestCategory: PropTypes.string.isRequired,
      contestTags: PropTypes.array.isRequired,
      createdDate: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      fileName: PropTypes.string,
      link: PropTypes.string,
      forumTopicAlias: PropTypes.string.isRequired,
      forumTopicId: PropTypes.number.isRequired,
      id: PropTypes.number.isRequired,
      isLiked: PropTypes.bool.isRequired,
      userId: PropTypes.string.isRequired,
      author: PropTypes.object.isRequired,
    }).isRequired,
  };

  render() {
    const { practice } = this.props;
    return (
      <div className="section">
        <div className="article-detail">
          {practice ? (
            <React.Fragment>
              <div className="article-detail-date">{formatDate(practice.createdDate, 'full')}</div>


              <div className="article-detail-desc">
                <PracticeDetailCaseAside practice={practice} className="mobile-hide" />

                <div className="article-detail-desc-main">
                  <div className="article-detail-media  -mobile-offset">
                    <AttachedContent
                      vimeoLink={practice.link}
                      filename={practice.fileName}
                      fileId={practice.fileId}
                      className="article__attached-content"
                    />
                  </div>
                  <PracticeDetailCaseAside practice={practice} className="mobile-show" />
                  <h3 className="article-detail-desc-main-header">{practice.title}</h3>
                  <div
                    className="article-detail-desc-main-content wysiwyg"
                    dangerouslySetInnerHTML={{ __html: practice.description }}
                  />

                  <div className="btn-group">
                    <Link
                      to={`${paths.advocates.forumTopic}/${practice.forumTopicAlias}`}
                      className="btn"
                    >
                      {'Написать сообщение'}
                    </Link>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <Preloader />
          )}
        </div>
      </div>
    );
  }
}
